export const detailsDescription = {
  optionalExtras: {
    header: 'Optional Extras',
    content: [
      {
        name: 'Roadside Assistance',
        slug: 'roadsideAssistance',
        description: [
          'The vehicle will be repaired at the roadside or towed to a nearby garage - distances may vary (dependent on provider). This does not include cover from your home address.',
          'Please check your policy details with the insurance provider for full details of this cover.',
        ],
      },
      {
        name: 'Onward Travel',
        slug: 'altTravel',
        description: [
          'This will provide you with alternative transport if your vehicle cannot be repaired the same day, so you may continue your journey.',
          'Please check your policy details with the insurance provider for full details of this cover.',
        ],
      },
      {
        name: 'Home Start',
        slug: 'homeStart',
        description: [
          'If you break down within 1  mile of your home, usually your vehicle and at least 4 passengers will be recovered and brought to the nearest garage available to undertake the repair.',
          'Please check your policy details with the insurance provider for full details of this cover.',
        ],
      },
      {
        name: 'Relief Driver',
        slug: 'reliefDriver',
        description: [
          'If you are away from home and fall ill or are injured, and you are the only person able to drive your vehicle, a relief driver may be provided who will take you to a chosen destination.',
          'Please check your policy details with the insurance provider for full details of this cover.',
        ],
      },
      {
        name: 'Overnight Accommodation',
        slug: 'hotel',
        description: [
          'Overnight accommodation will be supplied if your car cannot be repaired in a reasonable time.',
          'Please check your policy details with the insurance provider for full details of this cover.',
        ],
      },
      {
        name: 'Car Hire',
        slug: 'carHire',
        description: [
          'A replacement car will be provided whilst your car is being repaired.',
          'Please check your policy details with the insurance provider for full details of this cover.',
        ],
      },
    ],
    contentLimiter: 6,
  },
  coverType: {
    header: "What's the difference in cover types?",
    content: [
      {
        name: 'Local',
        description: [
          'If your breakdown occurs further than 1 mile from your home address (distance may vary depending on provider), usually you, your vehicle and a maximum of 7 passengers will be recovered to the nearest garage which is able to undertake the repair.',
        ],
      },
      {
        name: 'Nationwide',
        description: [
          'Usually if your vehicle cannot be repaired on the same day, you and a maximum of 7 passengers will be brought to any destination of your choice within the UK.',
        ],
      },
      {
        name: 'European',
        description: [
          'This normally provides nationwide cover when in the UK plus roadside assistance and recovery within Europe for up to 90 days in a policy term (please see provider details for full information).',
        ],
      },
      {
        name: 'Vehicle',
        description: [
          'Will usually cover the vehicle specified on the insurance policy and anyone insured to drive the vehicle.',
        ],
      },
      {
        name: 'Personal',
        description: [
          'Usually provides cover for the person named on the policy for any vehicles they drive. Some providers may cover up to 4 people on one policy provided they all live at the same address.',
        ],
      },
    ],
  },
};
